/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Config } from '../schema/pg-config.types';
import { getUiSchemaOption } from './pg-config.util';

export const serialize = (config: NonNullable<Config | Config[keyof Config]>): Record<string, string> => {
  let result: Record<string, string> = {};

  for (const [key, value] of Object.entries(config)) {
    if (value === null || Array.isArray(value)) {
      throw new Error('received null or array while serializing PgConfig JSON schema object');
    } else if (typeof value !== 'object') {
      const options = getUiSchemaOption(key);
      result[key] = options?.unit ? `${value}${options?.unit}` : value.toString();
    } else {
      result = {
        ...result,
        ...serialize(value),
      };
    }
  }

  return result;
};
